import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12d430cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "appoint-coordinator"
}
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Appoint self as Trust Coordinator")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "practice-short-summary" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Practice Name:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Address:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Do you want to be a Trust Coordinator for this Practice including all offices/branches? ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " A Trust Coordinator is responsible for submitting the annual trust reports and will receive all trust related communications. ", -1))
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = { class: "button-controls" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")

  return (_ctx.modalOpened)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "fal fa-times close-icon",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.cancel()), ["prevent"]))
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.practiceName), 1),
                      _hoisted_9,
                      _createElementVNode("div", null, _toDisplayString(_ctx.practice.practice?.address), 1)
                    ]),
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.submitting)
                        ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                            key: 0,
                            class: "loading-indicator",
                            showLoadingText: false
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-outline dark",
                        disabled: _ctx.submitting,
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.cancel()), ["prevent"]))
                      }, "Cancel", 8, _hoisted_14),
                      _createElementVNode("button", {
                        class: "btn btn-secondary mr-2",
                        disabled: _ctx.submitting,
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.appoint()), ["prevent"]))
                      }, "Appoint Self", 8, _hoisted_15)
                    ])
                  ])
                ])
              ], 512)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}